module.exports = __webpack_public_path__ + "img/Aliza Verver.b410299b.png";